export default __webpack_public_path__ + "static/media/dining-room.f7df24cd.webp";